import { useIntl } from 'react-intl';
import Dot from './Dot';
import { NavLink } from 'react-router-dom';
import { ReactComponent as Arrow } from '../../../../icons/icon-arrow-blue.svg';
import List from './List';

const Menu = ({ items }) => {
  const { formatMessage } = useIntl();

  return (
    <div className='integration__menu'>
      <List direction='column'>
        {items?.map(({ labeli18n, url, isActive = true }, index) => {
          const linkDisabledStyle = {
            color: '#19192B66',
            cursor: 'not-allowed',
            pointerEvents: 'none',
          };

          return (
            <NavLink
              to={url}
              key={index}
              style={{
                ...(!isActive && linkDisabledStyle),
              }}
            >
              {formatMessage({ id: labeli18n })}

              <Dot size='small'>
                <Arrow />
              </Dot>
            </NavLink>
          );
        })}
      </List>
    </div>
  );
};

export default Menu;
